<script setup>
import apiManager from '@/api';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import DayOfPage from './DayOfPage.vue';

const props = defineProps({
  email: String,
  id: String,
});

const statuses = {
  default: '',
  loading: 'loading',
  success: 'success',
  error: 'error',
};
const status = ref('');
const submitQuestion = async (questionText) => {
  try {
    status.value = statuses.loading;
    await apiManager.events.submitQuestion({
      eventId: props.id,
      askerEmail: props.email,
      questionText,
    });

    status.value = statuses.success;
  } catch (e) {
    status.value = statuses.error;
    setTimeout(() => {
      status.value = statuses.default;
    }, 3000);
  }
};

const store = useStore();

const event = computed(() => store.getters['events/event'](props.id));

</script>
<template>
<day-of-page @submit-question="submitQuestion"
  :event="event"
  :statuses="statuses"
  :status="status" />
</template>
